import nanuri from "./nanuri";
import * as korpay from "./korpay";

export default {
    nanuri,
    ...korpay,
};
